<h2 matDialogTitle>Server Version</h2>
<mat-dialog-content>
    <div class="grid grid-cols-2">
      <div><strong>Artifact</strong></div>
      <div>{{versionInfo.value()?.artifact}}</div>
      <div><strong>Group</strong></div>
      <div>{{versionInfo.value()?.group}}</div>
      <div><strong>Name</strong></div>
      <div>{{versionInfo.value()?.name}}</div>
      <div><strong>Version</strong></div>
      <div>{{versionInfo.value()?.version}}</div>
      <div><strong>Time</strong></div>
      <div>{{versionInfo.value()?.time}}</div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Schließen</button>
</mat-dialog-actions>
